<template>
    <div class="add-new">
        <a class="inner" href="#" @click.prevent.stop="open()">
            <div class="icon">+</div>
        </a>

        <modal v-if="show_modal"
               :show="true"
               size="xl"
               @close="show_modal = false"
               :id="utils.randomId({prefix: 'modal'})">

            <template #title>Add Activity / Resource</template>

            <p>
                Add activity or upload a resource to the project canvas.
            </p>

            <tabs :tabs="{activity: 'Add Activity', resource: 'Add Resource'}" tab-size="lg">

                <template #tab-content-activity>
                    <add-activity-tab-content :stage="stage" @selected="activitySelected( $event )"/>
                </template>

                <template #tab-content-resource>
                    <add-resource-tab-content @upload="resourceUploaded( $event )"/>
                </template>

            </tabs>


            <template #footer>
                <button class="btn btn-success" @click.prevent.stop="close()">Done</button>
            </template>

        </modal>

    </div>
</template>

<script>
import Tabs from "@/Components/Tabs";
import Modal from "@/Components/Common/Modal";
import AddActivityTabContent from "@/Components/Canvas/AddCanvasElement/AddActivityTabContent";
import AddResourceTabContent from "@/Components/Canvas/AddCanvasElement/AddResourceTabContent";
import utils from "@/mixins/utils";

export default {
    name: "AddNewCanvasElement",
    components: {Modal, Tabs, AddActivityTabContent, AddResourceTabContent},
    mixins: [utils],
    props: ['stage'],
    emits: ['add-element'],

    data(){
        return {
            show_modal: false,
        }
    },

    methods: {
        addNew(){

        },
        open(){
            this.show_modal = true;
        },
        close(){
            this.show_modal = false;
        },

        activitySelected(activity){
            this.$emit('add-element', activity);
        },

        resourceUploaded(resource){
            // TODO: Add resource to canvas.
        }

    }

}
</script>

<style lang="scss" scoped>
.add-new{
    background: #F8F8F8 no-repeat center / cover;
    border: #FFFFFF solid 2px;
    border-radius: 6px;
    padding: 100% 0 0;
    cursor: pointer;
    width: 100%;
    position: relative;
    // box-shadow: 0 2px 8px #00000029;
}

.inner{
    color: rgba($dark, 0.3);
    text-decoration: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    .icon{
        font-size: 3rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
